import { portalApi } from "@services/api/portalApi";

type StudentLateInfo = {
    numberOfLates: number;
    overallLateTime: number;
    equivalentLessonsMissed: number;
}

export async function getStudentLates(studentNo: string) {
    try {
        const response = await portalApi.get<StudentLateInfo>(`/students/${studentNo}/attendance/lates`);
        return response.data;
    } catch (error) {
        console.error("Error fetching student's lates:", error);
        throw error;
    }
}
